import { Box, Modal, Typography } from '@mui/material';
import { Form } from 'react-final-form';
import * as yup from 'yup';

import { validateFormValues } from '../../../utils/forms/validation';
import FormButton from '../../forms/FormButton/FormButton';
import FormTextField from '../../forms/FormTextField/FormTextField';

import './ReportModal.scss';

const validate = validateFormValues(
    yup.object().shape({
        reason: yup.string().required(),
    }),
);

interface ReportModalProps {
    titleText: string;
    open: boolean;
    setOpen: React.Dispatch<React.SetStateAction<boolean>>;
    reportAction: (reason: string) => void;
}

const ReportModal = (props: ReportModalProps): JSX.Element => {
    const onCloseHandler = (): void => {
        props.setOpen(false);
    };

    const onSubmitHandler = (values: any): void => {
        if (values.reason) {
            props.reportAction(values.reason);
        }
    };

    return (
        <Modal
            className='report-modal'
            open={props.open}
            onClose={onCloseHandler}
        >
            <Box>
                <Typography variant='h6'>{props.titleText}</Typography>
                <Form
                    onSubmit={onSubmitHandler}
                    validate={validate}
                    render={({
                        handleSubmit,
                        form,
                        submitting,
                        pristine,
                        invalid,
                    }) => (
                        <form onSubmit={handleSubmit}>
                            <FormTextField
                                name='reason'
                                label='Reporting reason... '
                                fullWidth
                                required
                                autoFocus
                                multiline
                                minRows={3}
                                maxRows={5}
                            />
                            <FormButton
                                disabled={submitting || pristine || invalid}
                                type='submit'
                            >
                                Submit
                            </FormButton>
                        </form>
                    )}
                />
            </Box>
        </Modal>
    );
};

export default ReportModal;
